var Curriculog = Curriculog || {};

Curriculog.CurrentStepFilter = (function ($, _, Backbone, CurrentStepFilter) {

    CurrentStepFilter = Curriculog.DropdownFilterView.extend({
        initialize: function() {
            Curriculog.DropdownFilterView.prototype.initialize.apply(this, arguments);

            this.listenTo(Backbone, 'ap:change', this.modifyCurrentSteps);
        },

        getSelectedValue: function() {
            var param = this.params.queryParams.get(this.filterParam);
            return param.hasOwnProperty('name') ? param.name : '';
        },

        set: function() {
            var currentStep = this.$el.val() ? this.$el.val() : '';
            this.params.queryParams.set(this.filterParam, currentStep);
        },

        modifyCurrentSteps: function (options) {
            if (!_.isEmpty(options) && !this.disabled) {
                var currentSteps = this.collection,
                    apValue = parseInt(options.value),
                    value = this.$el.val(),
                    filter = {};

                if (options.type !== 'all') {
                    // Check whether the value is NaN (meaning it is an AP type) to set the correct apValue
                    filter[options.type] = isNaN(apValue) ? options.value : apValue;

                    // Filter the collection depending on the AP filter selection chosen
                    currentSteps = new Curriculog.CurrentSteps(this.collection.where(filter));

                    // Check to see if the value selected is in the filtered collection of current step names
                    value = currentSteps.where({name: value}).length ? value : '';
                }

                // Rebuild the dropdown with the modified collection
                this.buildDropdown(currentSteps, value);
            }
        },

        buildDropdown: function (collection, value) {
            var attributes = {},
                currentUniqueStepNames = [];

            this.getDropdownAttributes(attributes);

            collection = collection ? collection : {};

            if (collection.length) {
                // Only show the unique step names in the dropdown
                currentUniqueStepNames = _.uniq(collection.pluck('name'));
            }

            var dropdown = new Curriculog.CurrentStepDropdownView({
                collection: currentUniqueStepNames,
                attributes: attributes,
                firstOption: this.firstOption,
                noAvailableOptionsMessage: this.noAvailableOptionsMessage,
                selectedValue: value,
            });

            this.replaceDropdownDomElement(dropdown, value);
        },
    });

    return CurrentStepFilter;

})($, _, Backbone, Curriculog.CurrentStepFilter || {});